@if (showBackgroundPicker && item) {
  <div class="background-color-picker">
    <coin-color-picker [(ngModel)]="item.en.sideData.backgroundColor"></coin-color-picker>
  </div>
  <div class="background-color-picker">
    <coin-color-picker
      [isTextColorPicker]="true"
      [(ngModel)]="item.en.sideData.textColor"></coin-color-picker>
  </div>
}

<div class="email-header-container">
  @if (item.en.sideData) {
    <coin-v2-text-input
      [label]="'cms.emails.date-part' | translate"
      [(ngModel)]="item.en.sideData.datePartText" />
    <coin-v2-text-input
      [label]="'cms.emails.main-headline' | translate"
      [(ngModel)]="item.en.sideData.mainHeadline" />
    <coin-v2-text-input
      [label]="'cms.emails.sub-headline' | translate"
      [(ngModel)]="item.en.sideData.subHeadline" />
  }
</div>
<div class="email-header-container">
  @if (item.en.sideData) {
    <coin-v2-text-input
      [label]="'cms.emails.email-button-text-header' | translate"
      [(ngModel)]="item.en.sideData.actionButtonText" />
    <coin-v2-text-input
      [label]="'cms.emails.email-button-link-header' | translate"
      [(ngModel)]="item.en.sideData.actionButtonLink" />
  }
</div>
<div class="email-image-container">
  @if (item.en.sideData) {
    <coin-v2-checkbox
      [label]="'cms.emails.select-no-header-image' | translate"
      [(ngModel)]="item.en.sideData['no-header-image']"></coin-v2-checkbox>
  }
  @if (!item?.en?.sideData['no-header-image']) {
    <div>
      <img
        aria-label="some header image"
        class="full-width-email-header"
        [src]="item?.en['otherImage'] ?? ''" />
      <coin-v2-button
        [type]="'secondary'"
        [icon]="'edit'"
        [iconPos]="'right'"
        [text]="'cms.emails.change-header-image-button' | translate"
        (click)="editPicture()"></coin-v2-button>
    </div>
  }
</div>
